<template>
  <div class="china-market">
    <a-layout>
        <a-layout-content>
          <!-- 顶部切换 行情 -->
          <TopMenu class="board-tabs" @fatherMethod="fatherMethod"></TopMenu>
          <!-- tab切换: 上证指数 -->
          <div v-show="menuIdx==0" class="market-summary">
            <div ref="tabs" class="market-panel cn-index-panel">
              <CardMain ref="tabMain">
                <Chart market-polling :active="menuIdx === 0" :width="tabChartWidth" :height="tabChartHeight" />
              </CardMain>

            </div>
            <div class="market-panel cn-breadth-panel">
              <TitleHeader title="今日股市"/>
              <CardMain padding="0 23px">
                  <div class="jinrigushi-wrap flex justify-content__center flex-direction__column" v-loading="summaryLoading && !myChart" element-loading-background="var(--theme-bg)">
                    <div id="echartsRecords" ref="echartsRecords" style="width: 100%;min-height:250px;margin-top:-30px;"></div>
                    <div style="margin-top:-20px;">
                        <div style="display: flex;justify-content: space-between;text-align: center;margin-bottom: 6px;">
                            <div class="up-count" style="width: 33.33%;"></div>
                            <div class="flat-count" style="width: 33.33%;"></div>
                            <div class="down-conut" style="width: 33.33%;"></div>
                        </div>
                        <div style="display: flex;width: 100%;">
                            <div class="progress-up" style="background-color: var(--quote-up);height: 10px;border-radius: 2px;" :style="{'width':progress_up_width}"></div>
                            <div class="progress-flat" style="background-color: #393d49;height: 10px;border-radius: 2px;" :style="{'width':progress_flat_width}"></div>
                            <div class="progress-down" style="background-color: var(--quote-down);height: 10px;border-radius: 2px;" :style="{'width':progress_down_width}"></div>
                        </div>
                    </div>
                    <div id="up_ratio_comment" class="layui-text text-center" style="clear:both;padding: 10px 0px;text-align: center;"></div>
                  </div>
              </CardMain>
            </div>
            <div class="market-panel cn-industry-panel">
              <div style="height: 36px;line-height: 36px;background: var(--theme-header);color: var(--theme-label);display: flex;cursor: pointer;">
                  <div v-for="(i,idx) in tabList" @click="tabChange(idx)" :class="tab_type == i.type?'home_zs_box home_zs_active':'home_zs_box'">{{i.title }}</div>
              </div>
              <!-- <TitleHeader title="领涨概念"/> -->
              <CardMain>
                  <CardTable v-for="tab in tabList" :key="tab.type" v-show="tab_type === tab.type" :market-polling="menuIdx === 0 && tab_type === tab.type" @card-table-click="get_board_click" :type="tab.type"/>
              </CardMain>
            </div>
          </div>
          <div v-show="menuIdx==0" class="rank-title">
            <span>今日排行</span><div v-if="rankPanelCount > 3"><button type="button" aria-label="上一组排行" @click="scrollRanks(-1)">‹</button><button type="button" aria-label="下一组排行" @click="scrollRanks(1)">›</button></div>
          </div>
          <div ref="rankGrid" v-show="menuIdx==0" class="rank-grid cn-rank-grid">
            <div class="rank-panel">
              <TitleHeader title="当日涨幅榜"/>
              <CardMain v-loading="rankLoading[0] && !riseList1.length" element-loading-background="var(--theme-bg)">
                  <MinuteTable :list="riseList1" @code-click="codeClickFun" :tableHead="tabHead1"/>
              </CardMain>
            </div>
            <div class="rank-panel">
              <TitleHeader title="当日跌幅榜"/>
              <CardMain v-loading="rankLoading[1] && !riseList2.length" element-loading-background="var(--theme-bg)">
                  <MinuteTable :list="riseList2" @code-click="codeClickFun" :tableHead="tabHead2"/>
              </CardMain>
            </div>
            <div class="rank-panel">
              <TitleHeader title="日价格振幅榜"/>
              <CardMain v-loading="rankLoading[2] && !riseList3.length" element-loading-background="var(--theme-bg)">
                <DayTable :list="riseList3" :tableHead="tabHead3" @code-click="codeClickFun" :classify="classify"/>
              </CardMain>
            </div>
            <div class="rank-panel">
              <TitleHeader title="日换手率榜"/>
              <CardMain v-loading="rankLoading[3] && !riseList4.length" element-loading-background="var(--theme-bg)">
                <DayTable :list="riseList4" :tableHead="tabHead4" @code-click="codeClickFun" :classify="classify2"/>
              </CardMain>
            </div>
          </div>
          <BoardTable v-for="category in 7" :key="category" :category-id="category" :market-polling="menuIdx === category" v-show="menuIdx === category" class="cn-board-table" @board-table-click="codeClickFun"/>
        </a-layout-content>
      </a-layout>
      <ChinaTradePanel v-if="jy_bool" ref="tradePanel" :key="symbol" :symbol="symbol" @close="jy_close" />
      <el-dialog :title="boardTitle" :visible.sync="gainianPageRs" custom-class="cn-board-dialog market-board-dialog" width="min(620px, 90vw)" top="10vh" :show-close="true" :close-on-click-modal="true" @closed="focusTrade">
        <div class="home-quotes-scroll">
          <table class="home-quotes-table">
            <thead><tr><th scope="col">代码</th><th scope="col">名称</th><th scope="col">最新价</th>
              <th scope="col">涨跌幅</th></tr></thead>
            <tbody>
              <tr v-for="item in sharedStockRows(boardList, 'cn')" :key="item.symbol" tabindex="0" @click="boardClickFun(item.symbol)" @keydown.enter="boardClickFun(item.symbol)"><td>{{item.code}}</td><td>{{item.name}}</td><td>{{ price(item.zxj) }}</td>
                <td :class="Number(item.zdf) < 0 ? 'quote-negative' : Number(item.zdf) > 0 ? 'quote-positive' : ''">{{ percent(item.zdf) }}</td></tr>
             
            </tbody>
          </table>
          <p v-if="boardLoading" class="board-list-state" role="status">加载中…</p>
          <p v-else-if="boardError" class="board-list-state" role="alert">{{ boardError }} <button type="button" @click="get_board_list">重试</button></p>
          <p v-else-if="!boardList.length" class="board-list-state">暂无股票数据</p>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import $ from 'jquery'
import TitleHeader from '../home/components/titleHeader';
import CardMain from '../home/components/CardMain';
import CardTable from '../home/components/CardTable';
import Chart from '../home/components/chart';
import MinuteTable from '../home/components/minuteTable';
import ChinaTradePanel from './components/ChinaTradePanel.vue';
import DayTable from '../home/components/dayTable';
import TopMenu from '../home/components/topMenu';
import {apiStockCje, apiStockDown, apiStockHsl, apiStockRiseRank, apiStockUp,stockRank,marketIndex,boardApi } from '@/utils/requestapis'
import BoardTable from "../home/components/BoardTable";
import * as echarts from 'echarts'
import { pollMarket, marketRequest, marketSummary, refreshChinaSimpleStocks } from '@/utils/marketRefresh'

import rankNavigation from './rankNavigation'
export default {
  mixins: [rankNavigation],
  name: "ChinaMarket",
  data() {
    return {
      curSideIndex: 0,
      search: "",
      chartsIndex: "1",
      chartTabIndex: 0,
      // tabList: [
      //   {title: "上证指数"},
      //   {title: "深证指数"},
      //   {title: "创业板指"}
      // ],
      SymbolCodes: [
        "000001.sh",
        "399001.sz",
        "399006.sz"
      ],
      tabChartWidth: 0,
      tabChartHeight: 0,
      page: {
        page: 1,
        page_size: 30,
      },
      tabHead1:['代码','名称','当日涨幅','最新价'],
      tabHead2:['代码','名称','当日跌幅','最新价'],
      riseList1:[],
      riseList2:[],
      tabHead3:['代码','名称','日价格振幅','当日涨跌幅'],
      classify: true,
      classify2: false,
      riseList3:[],
      tabHead4:['代码','名称','当日涨跌幅','日换手率'],
      riseList4:[],
      //riseList:[],
      menuIdx:0,
      overviewLoaded: false,
      overviewLoading: false,
      summaryLoading: false,
      rankLoading: [true, true, true, true],
      myChart:'',
      progress_up_width:'40%',
      progress_flat_width:'20%',
      progress_down_width:'40%',
      tabList: [
                    {title: "领涨概念",type:'gn'},
                    {title: "领涨行业",type:'hy2'},
                    {title: "领涨地区",type:'dy'}
      ],
      tab_type:'gn',
      symbol: "000001.sh",
      jy_bool:false,
      gainianPageRs:false,
      board:'',
      gainianPage:1,
      board_total_page:1,
      boardList:[],
      boardRequest: 0, boardLoading: false, boardError: '',
      boardTitle:'领涨概念',
      // Minute:
      // {
      //     // JSChart: null,
      //     SHChart: null,
      //     SZChart: null,
      //     BJchart: null,
      //     Option: DefaultData.GetMinuteOption(),
      // }
    };
  },
  watch: {
    menuIdx(value) { this.stopOverview(); if (value === 0) this.activateOverview() },
    '$store.state.quoteColorMode'() { if (this.breadthSections) this.initChart(this.breadthSections, this.breadthCounts) },
    '$store.state.theme'() { if (this.breadthSections) this.initChart(this.breadthSections, this.breadthCounts) }
  },
  mounted(){
    this.activateOverview()
      this.OnSize();
      this.$nextTick(() => {
        window.addEventListener('resize', this.OnSize);
      });
      this.$nextTick(() => {
        window.addEventListener('resize', this.handleResize)
      });
    // apiStockRiseRank(this.page).then((res) => {
    //   this.riseList = res.data;
    // })
  },
  beforeDestroy() { this.disposed = true; this.stopOverview(); if (this.myChart) this.myChart.dispose(); window.removeEventListener('resize', this.handleResize); window.removeEventListener('resize', this.OnSize) },
  components: {
    BoardTable,
      TitleHeader,
      CardMain,
      CardTable,
      Chart,
      MinuteTable,
      DayTable,
      ChinaTradePanel,
      TopMenu
  },
  methods: {
    sharedStockRows,
    price: quotePrice,
    percent: quotePercent,
    stopOverview() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activateOverview() {
      if (this.disposed || this.menuIdx !== 0 || this.stopRefresh) return
      try {
        if (this.overviewLoaded) await this.refreshOverview()
        else await this.loadOverview()
      } finally {
        if (!this.disposed && this.menuIdx === 0 && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshOverview(), 'cn')
      }
    },
    async loadOverview() {
      if (this.overviewLoading) return
      this.overviewLoading = true
      try {
        await Promise.allSettled([
          this.myChartInit(),
          ...[apiStockUp, apiStockDown, apiStockCje, apiStockHsl].map(async (load, index) => {
            try {
              const result = await load(this.page)
              if (!this.disposed && result && Array.isArray(result.data)) this['riseList' + (index + 1)] = result.data
            } finally { this.$set(this.rankLoading, index, false) }
          })
        ])
        this.overviewLoaded = true
      } finally { this.overviewLoading = false }
    },
    async refreshOverview() {
      if (this.disposed || this.menuIdx !== 0 || this.overviewLoading) return
      this.overviewLoading = true
      const rankRequests = [apiStockUp, apiStockDown, apiStockCje, apiStockHsl]
      try {
        await Promise.allSettled([
          this.myChartInit(true),
          this.gainianPageRs ? this.refreshBoardStocks() : Promise.resolve(),
          ...rankRequests.map(async (load, index) => {
            const result = await load(this.page)
            const rows = result && result.data
            if (!Array.isArray(rows) || this.disposed) return
            this['riseList' + (index + 1)] = rows
          })
        ])
      } finally { this.overviewLoading = false }
    },
    async refreshBoardStocks() {
      if (this.disposed || this.menuIdx !== 0 || !this.gainianPageRs || this.boardLoading || !this.boardList.length) return
      const board = this.board, request = this.boardRequest, rows = await refreshChinaSimpleStocks(this.boardList)
      if (!this.disposed && this.gainianPageRs && request === this.boardRequest && board === this.board) this.boardList = rows
    },
    boardClickFun(code) {
      this.gainianPageRs = false
      this.symbol = code
      this.jy_bool = true
    },
    focusTrade() { const panel = this.$refs.tradePanel; if (panel) panel.$el.focus() },
    get_board_click(obj){
      this.gainianPage = 1
      this.board = obj.code
      this.boardTitle = obj.name
      this.boardList = []
      this.boardError = ''
      this.get_board_list()
      this.gainianPageRs = true
    },
    async get_board_list(){
      const request = ++this.boardRequest, board = this.board, page = this.gainianPage
      this.boardLoading = true; this.boardError = ''
      if (page === 1) this.boardList = []
      try {
        const res = await boardApi({ board, page })
        if (this.disposed || request !== this.boardRequest || board !== this.board || !this.gainianPageRs) return
        if (!res || !Array.isArray(res.lists)) throw new Error('invalid board list')
        this.boardList = page === 1 ? res.lists : this.boardList.concat(res.lists)
      } catch (_) {
        if (!this.disposed && request === this.boardRequest) this.boardError = '股票列表加载失败，请重试'
      } finally { if (request === this.boardRequest) this.boardLoading = false }
    },
    jy_close(){
      this.jy_bool = false
    },
    codeClickFun(code) {
      let part1 = code.slice(0, 2);
      let part2 = code.slice(2);
      this.symbol = part2+'.'+part1
      this.jy_bool = true
      this.$nextTick(this.focusTrade)
    },
    myChartInit(refresh = false){
      if (!refresh) this.summaryLoading = true
      const source = refresh ? marketRequest('summary', { market: 'cn' }).then(value => marketSummary(value, 'cn')) : marketIndex()
      return source.then((data) => {
          if (this.disposed || !data || !Array.isArray(data.detail)) return
          var section = [];
          var count = [];
          data.detail.forEach((item, index) => {
            section.push(item.section);
            count.push(item.count);
          });
          var total = parseInt(data.down_count) + parseInt(data.up_count) + parseInt(data.flat_count);
          $('.up-count').html('涨：' + data.up_count);
          $('.flat-count').html('平：' + data.flat_count);
                        $('.down-conut').html('跌：' + data.down_count);
                        $('#up_ratio_comment').html(data.up_ratio_comment);//
                        this.progress_up_width = (data.up_count / total) * 100 + '%'
                        this.progress_flat_width = (data.flat_count / total) * 100 + '%'
                        this.progress_down_width = (data.down_count / total) * 100 + '%'
                        this.initChart(section, count);                       
      }).catch(() => {}).finally(() => { this.summaryLoading = false })
     
    },
    initChart(section,count) {
      this.breadthSections = section; this.breadthCounts = count
      const palette = getComputedStyle(document.documentElement)
      const up = palette.getPropertyValue('--quote-up').trim(), down = palette.getPropertyValue('--quote-down').trim(), flat = palette.getPropertyValue('--theme-muted').trim()
      if (!this.myChart) this.myChart = echarts.init(this.$refs.echartsRecords)
      var option = {
                        tooltip: {},
                        xAxis: {
                            data: section,
                            axisLabel: {
                                interval: 0,
                            },
                            splitLine: {     //网格线
                                "show": false
                            },
                            axisTick: {
                                show: false //不显示坐标轴刻度线
                            },
                            axisLine: {
                                show: false, //不显示坐标轴线
                            },
                        },
                        yAxis: {
                            type: 'value',
                            axisTick: {
                                show: false //不显示坐标轴刻度线
                            },
                            axisLine: {
                                show: false, //不显示坐标轴线
                            },
                            axisLabel: {
                                show: false, //不显示坐标轴上的文字
                            },
                            splitLine: {     //网格线
                                "show": false
                            },
                        },
                        series: [{
                            type: 'bar', //柱状
                            data: count,
                            barWidth: '40%',
                            itemStyle: {
                                normal: {
                                    color: function (params) {
                                        // var colorList = ['#ff4c3e','#ff0000', '#76300e', '#9a3403', '#b73801','#687087', '#0e8e31', '#0f762d', '#0f6328', '#008000', '#00c379'];
                                        const middle = Math.floor(section.length / 2)
                                        return params.dataIndex < middle ? up : params.dataIndex === middle ? flat : down
                                    },
                                    label: {
                                        show: true,  //开启显示
                                        position: 'top',  //在上方显示
                                        textStyle: {  //数值样式
                                            color: function (params) {
                                                const middle = Math.floor(section.length / 2)
                                                return params.dataIndex < middle ? up : params.dataIndex === middle ? flat : down
                                            },
                                            fontSize: 12
                                        }
                                    }
                                }
                            },
                        }]
                    };
                    
      this.myChart.setOption(option)
    },
    handleResize() {
      this.myChart?.resize()
    },
    fatherMethod(key){
      const category = Number(key)
      if (Number.isInteger(category) && category >= 0 && category <= 7) this.menuIdx = category
    },
    tabChange(index) {
      this.tab_type = this.tabList[index].type
    },
    onSearch(env) {
      console.log(env);
    },

    OnSize() {
      this.$nextTick(() => {
        if(this.$refs['tabMain']){
          this.tabChartWidth = this.$refs['tabMain'].$el.offsetWidth;
          // The index tabs and their gap occupy 42px above the chart canvas.
          this.tabChartHeight = Math.max(0, this.$refs['tabMain'].$el.offsetHeight - 42);
        }
      });
    },
      // CreateMinuteChart() {
      //   // 统一创建
      //   this.CreateSHChart();
      //   this.CreateSZChart();
      //   this.CreateBJChart();
      // },

      CreateSHChart() {
       this.$nextTick(() => {
        this.getSize(this.$refs.minute);
         // 上证指数
         if (this.Minute.SHChart) return;
        this.Minute.Option.Symbol=this.SymbolCodes[0];
        let chart=HQChart.Chart.JSChart.Init(this.$refs.minute);
        chart.SetOption(this.Minute.Option);
        this.Minute.SHChart=chart;
       })
      },

      CreateSZChart()
      {
        this.$nextTick(() => {
          this.getSize(this.$refs.minute2);
          // 深证指数
          if (this.Minute.SZChart) return;
          this.Minute.Option.Symbol=this.SymbolCodes[1];
          let chart=HQChart.Chart.JSChart.Init(this.$refs.minute2);
          chart.SetOption(this.Minute.Option);
          this.Minute.SZChart=chart;
        })
      },
      CreateBJChart()
      {
        this.$nextTick(() => {
          this.getSize(this.$refs.minute3);
          // 创业板指
          if (this.Minute.BJchart) return;
          this.Minute.Option.Symbol=this.SymbolCodes[2];
          let chart=HQChart.Chart.JSChart.Init(this.$refs.minute3);
          chart.SetOption(this.Minute.Option);
          this.Minute.BJchart=chart;
        })
      },
      getSize(minute) {
        var tabs = this.$refs['tabs'];
        var chartHeight = tabs.offsetHeight - 60;
        var chartWidth = tabs.offsetWidth - 20;
        var minute=this.$refs.minute; // 上证指数
        var minute2=this.$refs.minute2; // 深证指数
        var minute3=this.$refs.minute3; // 创业板指
          // console.log(minute3)
        [minute].forEach(m => {
          m.style.width = chartWidth+'px';
          m.style.height = chartHeight+'px';
        })
      }
  }
};
</script>

<style lang="scss">
@import "../../assets/normal.css";

html,
body,
#root-container,
.ant-layout {
  height: 100%;
}

//.ant-layout, .ant-layout * {
//  background: var(--theme-bg);
//}
.ant-layout-sider {
  width: 60px !important;
  max-width: 60px !important;
  min-width: 60px !important;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 64px;
}
.ant-menu-horizontal{
  background-color: var(--theme-header) !important;
  color: var(--theme-label) !important;
  border-bottom: none !important;
}
.ant-menu-horizontal > .ant-menu-item-selected {
  color: var(--theme-text) !important;
  border-bottom: 2px solid var(--theme-text) !important;
}
.sidebar-menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 96px;
  cursor: pointer;
  color: var(--theme-text);
  &.active {
    div {
      color: #e88a07;
    }
    .iconfont {

      color: #e88a07;
    }
  }
}

.color-rise {
  width: 20%;
  height: 12px;
  background-color: var(--quote-up);
}

.color-fall {
  height: 12px;
  background-color: var(--quote-down);
}

.tool-bar .ant-btn-link {
  color: var(--theme-text);
}

/*
 今日股市
*/
.jinrigushi-wrap {
  height: 100%;
}


// 今日投票
.jinri {
  padding-left: 8px;
  line-height: 35px;
  height: 35px;
  color: var(--theme-text);
  background-color: var(--theme-bg);
}

// flex样式
.flex {
  display: flex;
}

.align-item__center {
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.text-align__right{
  text-align: right;
}

.flex-direction__column {
  flex-direction: column;
}

.justify-content__center {
  justify-content: center;
}

.wdith-100 {
  width: 100%;
}

.mt-10{
  margin-top: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}
.tab-title-header-container>.title{
  background: var(--theme-header);
}
.home_zs_box{
  width: 120px;
  text-align: center;
}
.home_zs_active{
    color: var(--theme-text);
    //border-bottom: 2px solid var(--theme-text) !important;
}
.jy_box{
  position: fixed;
  z-index: 99999;
  right: 0;
  top: 0;
}
</style>

<style scoped>
.china-market { flex: 1; min-height: 0; overflow: auto; }
</style>
